/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPAccountList'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPAccountList'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPAccountListApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPAccountList);
  }
}(this, function(ApiClient, ERPAccountList) {
  'use strict';

  /**
   * ERPAccountList service.
   * @module api/ERPAccountListApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPAccountListApi. 
   * @alias module:api/ERPAccountListApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPAccountListImportAccountListsGet operation.
     * @callback module:api/ERPAccountListApi~eRPAccountListImportAccountListsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPAccountList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importAccountLists
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPAccountListApi~eRPAccountListImportAccountListsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPAccountList>}
     */
    this.eRPAccountListImportAccountListsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPAccountListImportAccountListsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPAccountList];

      return this.apiClient.callApi(
        '/ERPAccountList/importAccountLists', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPAccountListLoadAllGet operation.
     * @callback module:api/ERPAccountListApi~eRPAccountListLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPAccountList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPAccountListApi~eRPAccountListLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPAccountList>}
     */
    this.eRPAccountListLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPAccountListLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPAccountList];

      return this.apiClient.callApi(
        '/ERPAccountList/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPAccountListReplaceFinancialIndicatorGroupGet operation.
     * @callback module:api/ERPAccountListApi~eRPAccountListReplaceFinancialIndicatorGroupGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * replaceFinancialIndicatorGroup
     * @param {String} _4SAPIAppID 
     * @param {Integer} accountLevelID 
     * @param {Integer} targetIndicatorID 
     * @param {module:api/ERPAccountListApi~eRPAccountListReplaceFinancialIndicatorGroupGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPAccountListReplaceFinancialIndicatorGroupGet = function(_4SAPIAppID, accountLevelID, targetIndicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPAccountListReplaceFinancialIndicatorGroupGet";
      }

      // verify the required parameter 'accountLevelID' is set
      if (accountLevelID == undefined || accountLevelID == null) {
        throw "Missing the required parameter 'accountLevelID' when calling eRPAccountListReplaceFinancialIndicatorGroupGet";
      }

      // verify the required parameter 'targetIndicatorID' is set
      if (targetIndicatorID == undefined || targetIndicatorID == null) {
        throw "Missing the required parameter 'targetIndicatorID' when calling eRPAccountListReplaceFinancialIndicatorGroupGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'accountLevelID': accountLevelID,
        'targetIndicatorID': targetIndicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPAccountList/replaceFinancialIndicatorGroup', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
